export type TLicenseState = Record<string, never>

export const getInitialLicenseState = (): TLicenseState => {
    return {}
}

const moduleState = getInitialLicenseState()

export default moduleState
